var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_c('RecordPayment',{attrs:{"form":_vm.form},on:{"onChange":_vm.getOutstanding}})],1),_c('b-col',{attrs:{"cols":"7"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }